angular.module("ainapp")
    .controller("overdueSalesInvReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Overdue Sales Invoice";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                };

                //                $scope.ReportType = $stateParams.Type;
                //                if ($scope.ReportType == "Detail") {
                //                    $scope.ReportName = "Detail";
                //                } else {
                //                    $scope.ReportName = "Summary";
                //                }
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.OverDueSalesInvoiceInReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            VoucherNumber: {
                                type: "string",
                            },

                            "Customer.Name": {
                                type: "string",
                            },

                            NetTotal: {
                                type: "float",
                            },
                            TotalTax: {
                                type: "float",
                            },
                            GrandTotal: {
                                type: "float",
                            },
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                filterable: true,

                columns: [

                    {
                        field: "VoucherNumber",
                        title: "#",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                                            },
                    {
                        field: "Customer.Name",
                        title: "Customer",
                        headerTemplate: "{{LanguageData.Customer}}",
                                            },

                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.date}}",
                                            },

                    {
                        field: "NetTotal",
                        title: "NetTotal",
                        headerTemplate: "{{LanguageData.NetTotal}}",
                        template: "<div style='text-align: right'>#=kendo.toString(NetTotal, 'n')#</div>",

                                            },
                    {
                        field: "TotalTax",
                        title: "Total Tax",
                        headerTemplate: "{{LanguageData.TotalTax}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalTax, 'n')#</div>",

                                            },


                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        headerTemplate: "{{LanguageData.GrandTotal}}",
                        template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",

                                            },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button>",
                        width: '60px',
                        sticky: true
                        },


                                        ],
            };

            //                
            //                    $scope.KendoSource2 = new kendo.data.DataSource({
            //                batch: true,
            //                transport: {
            //                    read: function (o) {
            //
            //                        if ($scope.isFilter) {
            //
            //                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
            //                            o.data.FromDay = $scope.filter.FromDate.getDate();
            //                            o.data.FromYear = $scope.filter.FromDate.getFullYear();
            //
            //                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
            //                            o.data.ToDay = $scope.filter.ToDate.getDate();
            //                            o.data.ToYear = $scope.filter.ToDate.getFullYear();
            //
            //                            o.data.CustomerId = $scope.filter.CustomerId;
            //                            o.data.VoucherNo = $scope.filter.VoucherNo;
            //                            o.data.ProductId = $scope.filter.ProductId;
            //
            //                            o.data.CustomerIds = $scope.filter.CustomerIds;
            //                            o.data.ProductIds = $scope.filter.ProductIds;
            //                            o.data.CostCenters = $scope.CostCenters;
            //
            //
            //                            MainService.OverDueSalesInvoiceInSummaryReport(o.data).then(function (response) {
            //                                o.success(response.data);
            //                            }, function (err) {
            //                                o.success({
            //                                    Data: []
            //                                });
            //                                toastr.error("NetworkError");
            //                            })
            //                        } else {
            //                            o.success({
            //                                Data: []
            //                            });
            //                        }
            //
            //
            //                    },
            //
            //                },
            //                change: function (data) {},
            //                schema: {
            //                    data: "Data",
            //                    total: "Total",
            //                    model: {
            //                        id: "Id",
            //                        fields: {
            //                            "VoucherNumber": {
            //                                type: "string",
            //                                editable: false,
            //                            },
            //                            "Date": {
            //                                type: "date",
            //                                editable: false,
            //                            },
            //                            "Customer.Name": {
            //                                type: "string",
            //                                editable: false,
            //                            },
            //                            "BaseCurrency.Name": {
            //                                type: "string",
            //                                editable: false,
            //                            },
            //
            //                            NetTotal: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            GrossTotal: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            TotalDiscount: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            TotalOtherCharges: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            TotalExtraCharges: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            TotalTax: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            GrandTotal: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            LinkedRefNos: {
            //                                type: "number",
            //                                editable: false,
            //                            },
            //                            Remarks: {
            //                                type: "string",
            //                                editable: false,
            //                            },
            //
            //                        }
            //                    }
            //                },
            //                serverPaging: true,
            //                serverSorting: true,
            //                serverFiltering: true,
            //                pageSize: 20,
            //                aggregate: [{
            //                        field: "GrossTotal",
            //                        aggregate: "sum"
            //                    },
            //                    {
            //                        field: "NetTotal",
            //                        aggregate: "sum"
            //                        }, {
            //                        field: "TotalDiscount",
            //                        aggregate: "sum"
            //                        },
            //                    {
            //                        field: "TotalOtherCharges",
            //                        aggregate: "sum"
            //                        },
            //                    {
            //                        field: "TotalExtraCharges",
            //                        aggregate: "sum"
            //                        },
            //                    {
            //                        field: "TotalTax",
            //                        aggregate: "sum"
            //                        }, {
            //                        field: "GrandTotal",
            //                        aggregate: "sum"
            //                        }],
            //            });
            //
            //            $scope.KendoGridOptions2 = {
            //
            //                editable: false,
            //                pageable: true,
            //                toolbar: ["excel"],
            //                height: 700,
            //                resizable: true,
            //                dataSource: $scope.KendoSource2,
            //                pageSize: 20,
            //                pageable: {
            //                    input: false,
            //                    refresh: true,
            //                    pageSizes: true,
            //                    info: true,
            //                },
            //                sortable: true,
            //                scrollable: true,
            //                filterable: true,
            //                groupable: true,
            //                columnMenu: {
            //                    filterable: false,
            //                    filterable: true,
            //                },
            //
            //
            //                columns: [
            //
            //
            //                    {
            //                        field: "VoucherNumber",
            //                        title: "Doc No #",
            //                        width: "120px",
            //                        },
            //                    {
            //                        field: "Date",
            //                        title: "Doc Date",
            //                        template: '<p>{{dataItem.Date | date: "dd/MM/yyyy"}}</p>',
            //                        width: "120px",
            //                        },
            //                    {
            //                        field: "Customer.Name",
            //                        title: "Customer",
            //                        headerTemplate: $scope.LanguageData.Customer,
            //                        width: "200px",
            //                        },
            //                    {
            //                        field: "BaseCurrency.Name.Name",
            //                        title: "Currency",
            //                        headerTemplate: $scope.LanguageData.Currency,
            //                        width: "100px",
            //                        },
            //                    {
            //                        field: "LinkedRefNos",
            //                        title: "Linked Refs",
            //                        width: "150px",
            //                        },
            //                    {
            //                        field: "GrossTotal",
            //                        title: "Gross",
            //                        width: "100px",
            //                        aggregates: ["sum"],
            //                        template: "<div style='text-align: right'>#=kendo.toString(GrossTotal, 'n')#</div>",
            //                        footerTemplate: "#=kendo.toString(sum, 'n')#",
            //                        headerTemplate: kendo.template("<div class='headerright'>Gross</div>")
            //                        },
            //                    {
            //                        field: "TotalDiscount",
            //                        title: "Disc",
            //                        width: "100px",
            //                        aggregates: ["sum"],
            //                        template: "<div style='text-align: right'>#=kendo.toString(TotalDiscount, 'n')#</div>",
            //                        footerTemplate: "#=kendo.toString(sum, 'n')#",
            //                        headerTemplate: kendo.template("<div class='headerright'>Disc</div>")
            //                        },
            //
            //                    {
            //                        field: "TotalOtherCharges",
            //                        title: "Other CH",
            //                        width: "100px",
            //                        aggregates: ["sum"],
            //                        template: "<div style='text-align: right'>#=kendo.toString(TotalOtherCharges, 'n')#</div>",
            //                        footerTemplate: "#=kendo.toString(sum, 'n')#",
            //                        headerTemplate: kendo.template("<div class='headerright'>Other CH</div>")
            //                        },
            //                    {
            //                        field: "NetTotal",
            //                        title: "Net",
            //                        width: "100px",
            //                        aggregates: ["sum"],
            //                        template: "<div style='text-align: right'>#=kendo.toString(NetTotal, 'n')#</div>",
            //                        footerTemplate: "#=kendo.toString(sum, 'n')#",
            //                        headerTemplate: kendo.template("<div class='headerright'>Net</div>")
            //                        },
            //                    {
            //                        field: "TotalTax",
            //                        title: "Tax",
            //                        width: "100px",
            //                        aggregates: ["sum"],
            //                        template: "<div style='text-align: right'>#=kendo.toString(TotalTax, 'n')#</div>",
            //                        footerTemplate: "#=kendo.toString(sum, 'n')#",
            //                        headerTemplate: kendo.template("<div class='headerright'>Tax</div>")
            //                        },
            //                    {
            //                        field: "TotalExtraCharges",
            //                        title: "Extra CH",
            //                        width: "100px",
            //                        aggregates: ["sum"],
            //                        template: "<div style='text-align: right'>#=kendo.toString(TotalExtraCharges, 'n')#</div>",
            //                        footerTemplate: "#=kendo.toString(sum, 'n')#",
            //                        headerTemplate: kendo.template("<div class='headerright'>Extra CH</div>")
            //                        },
            //
            //                    {
            //                        field: "GrandTotal",
            //                        title: "Total",
            //                        width: "100px",
            //                        aggregates: ["sum"],
            //                        template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",
            //                        footerTemplate: "#=kendo.toString(sum, 'n')#",
            //                        headerTemplate: kendo.template("<div class='headerright'>Total</div>")
            //                        },
            //                    {
            //                        field: "Remarks",
            //                        title: "Remarks",
            //                        width: "220px",
            //                        },
            //                    {
            //                        title: "Options",
            //                        headerTemplate: "{{LanguageData.Options}}  ",
            //                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.Id, \"Purchase Request\")'></button>",
            //                        width: '100px',
            //                        sticky: true
            //                        },
            //
            //
            //                    ],
            //            };
            //
            //

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }



            $scope.View = function (data) {
                $state.go("viewSalesInvoice", {
                    VoucherId: data.Id
                })
            }


                    }])
